import {inject, Injectable} from '@angular/core';
import {TagStore} from '../stores/tag.store';
import {DocumentVaultFlatTagDefinition} from '../models/document/document-vault-flat-tag-definition.model';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {TagState} from '../modules/akita-mimic/models/store-states/tag-state.model';

@Injectable({ providedIn: 'root' })
export class TagQuery extends QueryService<TagState> {

    public constructor() {
        const store = inject(TagStore);
        super(store);
    }

    public getDocumentVaultTagDefinitions(): Array<DocumentVaultFlatTagDefinition> {
        return this.getValue().documentVaultTagDefinitions;
    }
}
